@let isBlackKnight = isBlackKnight$ | async;

<red-header-content>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="more"></ion-back-button>
    </ion-buttons>
    <ion-title>Login Credentials</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="onSubmit()" [disabled]="referralForm.invalid || (isBlackKnight ? loginForm.invalid : false)"
        >Save<ion-icon slot="end" name="checkmark-circle-outline"></ion-icon
      ></ion-button>
    </ion-buttons>
  </ion-toolbar>
</red-header-content>
<red-page-content>
  <ion-list [inset]="true" lines="full" class="no-last-line">
    <ion-item-group>
      <form [formGroup]="referralForm" (ngSubmit)="onSubmit()">
        <ion-item-divider color="primary">
          <ion-label>Onboarding</ion-label>
        </ion-item-divider>
        <ion-item>
          <ion-input
            [redErrorMessage]="referralFormValidationErrors['code']"
            labelPlacement="stacked"
            placeholder="e.g abcde123"
            inputmode="text"
            [required]="true"
            type="text"
            formControlName="code"
            [maxlength]="20"
          >
            <div slot="label">Referral Code:<ion-text color="danger">*</ion-text></div>
          </ion-input>
        </ion-item>
      </form>
    </ion-item-group>
  </ion-list>
  @if (isBlackKnight) {
  <ion-list [inset]="true" lines="full" class="no-last-line">
    <ion-item-group>
      <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
        <ion-item-divider color="primary">
          <ion-label> Login Credentials </ion-label>
        </ion-item-divider>
        <ion-item>
          <ion-input
            [redErrorMessage]="loginFormValidationErrors['username']"
            labelPlacement="stacked"
            inputmode="text"
            [required]="true"
            type="text"
            formControlName="username"
          >
            <div slot="label">Username: <ion-text color="danger">*</ion-text></div>
          </ion-input>
        </ion-item>
        <ion-item>
          <ion-input
            [redErrorMessage]="loginFormValidationErrors['password']"
            type="password"
            labelPlacement="stacked"
            inputmode="text"
            [required]="true"
            formControlName="password"
          >
            <ion-input-password-toggle slot="end"></ion-input-password-toggle>
            <div slot="label">Password:<ion-text color="danger">*</ion-text></div></ion-input
          >
        </ion-item>
      </form>
    </ion-item-group>
  </ion-list>
  } @if (isBlackKnight && (debugMode$ | async)) {
  <ion-list [inset]="true" lines="full" class="no-last-line">
    <ion-item-divider color="warning">
      <ion-label>Actions</ion-label>
    </ion-item-divider>
    <ion-item [detail]="true" [routerLink]="['change-password']">
      <ion-label color="warning">Change Password</ion-label>
      <ion-icon color="warning" name="create-outline" slot="start"></ion-icon>
    </ion-item>
  </ion-list>
  }
</red-page-content>
